/**
 * @overview 问卷设计
 * @author jzhu
 * @date 2020-3-25
 */
import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { framework_tool, component_tool } from '../../../../tool'
import { WizQuestionnair } from '../../../../module'
let { WizContainer } = framework_tool
let { WizSpin, WizRow, WizCol, WizButton } = component_tool
import './index.less'

class SurveyQuestionDetail extends WizContainer {

  componentName = 'SurveyQuestionDetail'

  constructor(props) {
    super(props)
    this.state = {
      surveyId: props.surveyId,
      sourceId: props.sourceId,
      type: props.type,
      status: 0,
      resetTime: new Date().getTime()
    }
  }

  _componentDidMount() {
    let { type, surveyId,sourceId} = this.state
    if (['survey', 'update'].includes(type)) {
      this.doAction({
        path: 'survey/getSurveyInfo',
        payload: {
          key: 'surveyInfo_' + sourceId,
          apiParams: { id: sourceId }
        }
      })
    } else if ('temp' === type) {
      this.doAction({
        path: 'surveyTemplate/getSurveyTemplateInfo',
        payload: {
          key: 'surveyTemplateInfo_' + sourceId,
          apiParams: { id: sourceId }
        }
      })
    } else {
      this.doActions([
        {
          path: 'survey/getSurveyInfo',
          payload: {
            key: 'getSurveyInfo',
            apiParams: { id: surveyId }
          }
        }
      ])
    }
  }

  _createQuestions(values) {
    this.doAction({
      path: 'survey/createQuestions',
      payload: {
        key: 'createQuestions_' + this.state.surveyId,
        apiParams: { surveyId: this.state.surveyId, questions: values }
      }
    })
  }

  _updateQuestions(values) {
    this.doAction({
      path: 'survey/updateQuestions',
      payload: {
        key: 'updateQuestions_' + this.state.surveyId,
        apiParams: { surveyId: this.state.surveyId, questions: values }
      }
    })
  }

  _saveAndNext = () => {
    this.setState({ status: 1 }, () => {
      let values = this._fitterValues()
      if (this.state.type === 'update') {
        this._updateQuestions(values)
      } else {
        this._createQuestions(values)
      }
    })
  }

  _saveAndBack = () => {
    this.setState({ status: 2 }, () => {
      let values = this._fitterValues()
      if (this.state.type === 'update') {
        this._updateQuestions(values)
      } else {
        this._createQuestions(values)
      }
    })
  }

  _onReset = () => {
    this.setState({ resetTime: new Date().getTime() })
  }

  _fitterValues() {
    return this._survey && this._survey._fitterValues()
  }

  propsAndStateOnChange = {
    createQuestions: this._createQuestionsOnChange.bind(this),
    updateQuestions: this._updateQuestionsOnChange.bind(this),
  }

  _createQuestionsOnChange(nextProps, nextState) {
    if (nextProps.createQuestions.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    }
    return true
  }

  _updateQuestionsOnChange(nextProps, nextState) {
    if (nextProps.updateQuestions.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    } else {
      wizNotice.error(nextProps.updateQuestions.msg)
      return false;
    }
    return true
  }

  _prev = () => {
    this.props.prevFunc && this.props.prevFunc()
  }

  _render() {
    let { data } = this.props.info
    const tabs = [{ name: '基本题型', type: 'question' }]
    const classNames = {
      siderbarClass: 'survey-siderbar',
      pageClass: 'survey-page'
    }
    let questionnairProps = {
      key: data && data.id + this.state.resetTime,
      editors: data && data.questions,
      ref: survey => this._survey = survey,
      ...classNames,
      tabs,
      renderTitle: () => this._renderTitle('问卷标题', '问卷说明'),
      renderTabs: () => this._renderTabs(tabs)
    }
    return (
      <>
        <WizSpin tip={'加载中'} spinning={this.props.loading}>
          <WizQuestionnair {...questionnairProps} />
          <WizRow className='survey-button-row'>
            <WizCol>
              <WizButton title='上一步' onClick={this._prev}>上一步</WizButton>
              <WizButton title='保存并进入下一步' type='primary' onClick={this._saveAndNext}>保存并进入下一步</WizButton>
              <WizButton title='保存并返回' onClick={this._saveAndBack}>保存并返回</WizButton>
              <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
            </WizCol>
          </WizRow>
        </WizSpin>
      </>
    )
  }

  _renderTabs(tabs) {
    return (
      <div className='survey-tabs'>
        {
          tabs.map((data, index) => {
            return (
              <div key={data.type} className='survey-active-tab'>
                {data.name}
              </div>
            )
          })
        }
      </div>
    )
  }

  _renderTitle(title, intro) {
    return (
      <div className='survey-title'>
        {title}
        <div className='survey-intro'>
          {intro}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { survey, surveyTemplate } = state
  let { type, surveyId,sourceId } = ownProps
  const createQuestions = modelUtils.getModelEntity(survey, 'createQuestions_' + surveyId)
  const updateQuestions = modelUtils.getModelEntity(survey, 'updateQuestions_' + surveyId)
  const surveyInfo = modelUtils.getModelEntity(survey, "getSurveyInfo");

  let info = {}
  let loading = false
  if (['survey', 'update'].includes(type)) {
    info = modelUtils.getModelEntity(survey, 'surveyInfo_' + sourceId)
    const load = modelUtils.getLoadingState(state, 'survey')
    loading = load.surveyLoading
  } else if ('temp' === type) {
    info = modelUtils.getModelEntity(surveyTemplate, 'surveyTemplateInfo_' + sourceId)
    const load = modelUtils.getLoadingState(state, 'surveyTemplate')
    loading = load.surveyTemplateLoading
  } else {
    info = surveyInfo
    const load = modelUtils.getLoadingState(state, 'survey')
    loading = load.surveyLoading
  }
  return {
    info,
    createQuestions,
    updateQuestions,
    surveyInfo,
    loading
  }
}

export default connect(mapStateToProps)(SurveyQuestionDetail)
